// The collection's series. Each is its own line of booklets, told apart on
// the table by its accent band and badge; every cover shares the black
// Icons-style ground with the model lit large on it.

export type SeriesKey =
  | 'hardware'
  | 'founders'
  | 'frontier'
  | 'great-minds'
  | 'rotation'

export interface Series {
  key: SeriesKey
  name: string
  // Printed in the cover's accent band.
  badge: string
  accent: string
  // Ink on the accent band.
  accentInk: string
}

export const SERIES: Series[] = [
  {
    key: 'hardware',
    name: 'Hardware',
    badge: 'Hardware Icons',
    accent: '#E3000B',
    accentInk: '#FFFFFF',
  },
  {
    key: 'founders',
    name: 'Founders',
    badge: 'Founders',
    accent: '#F2C12E',
    accentInk: '#1B1B1B',
  },
  {
    key: 'frontier',
    name: 'Frontier',
    badge: 'Frontier',
    accent: '#C6F432',
    accentInk: '#111111',
  },
  {
    key: 'great-minds',
    name: 'Great Minds',
    badge: 'Great Minds',
    accent: '#C9A227',
    accentInk: '#1B1B1B',
  },
  {
    key: 'rotation',
    name: 'Rotation',
    badge: 'Rotation',
    accent: '#FF5A36',
    accentInk: '#FFFFFF',
  },
]

export function seriesFor(key: SeriesKey) {
  return SERIES.find((s) => s.key === key)!
}

// Set codes run in a block of ten thousand per series (10001, 20001, …), so
// two series' first sets never share a code.
export function setCode(series: SeriesKey, number: number) {
  const block = SERIES.findIndex((s) => s.key === series) + 1
  return String(block * 10000 + number)
}
